module.exports = __webpack_public_path__ + "static/media/sausage_kl_cafe_menu.d91a2e4d.png";